export default __webpack_public_path__ + "static/media/facebook.501c8b70.svg";